interface InputControlsProps {
  model: string;
  onModelChange: (value: string) => void;
  version: string;
  onVersionChange: (value: string) => void;
  onLoadTemplate: () => void;
  onClear: () => void;
}

export function InputControls({
  model,
  onModelChange,
  version,
  onVersionChange,
  onLoadTemplate,
  onClear
}: InputControlsProps) {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6 border border-gray-200 dark:border-gray-700">
      {/* Section Header */}
      <div className="flex items-center gap-2 mb-6">
        <span className="text-2xl">⚙️</span>
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Input Configuration</h3>
      </div>

      {/* Action Buttons */}
      <div className="flex gap-3 mb-6">
        <button
          onClick={onLoadTemplate}
          className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors font-medium text-sm flex items-center gap-2"
        >
          <span>📋</span>
          Load Template
        </button>
        
        <button
          onClick={onClear}
          className="px-4 py-2 bg-gray-600 hover:bg-gray-700 dark:bg-gray-700 dark:hover:bg-gray-600 text-white rounded-lg transition-colors font-medium text-sm flex items-center gap-2"
        >
          <span>🗑️</span>
          Clear
        </button>
      </div>

      {/* Optional Parameters */}
      <div className="border-t border-gray-200 dark:border-gray-700 pt-6">
        <h4 className="text-sm font-semibold text-gray-900 dark:text-white mb-4">Optional Parameters</h4>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Model <span className="text-gray-500 text-xs">(optional)</span>
            </label>
            <input
              type="text"
              value={model}
              onChange={(e) => onModelChange(e.target.value)}
              placeholder="e.g., default-v1"
              className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 text-sm transition-colors hover:border-blue-400 focus:border-blue-500 focus:outline-none"
            />
            <p className="text-xs text-gray-600 dark:text-gray-400 mt-1">Optional model identifier</p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Version <span className="text-gray-500 text-xs">(optional)</span>
            </label>
            <input
              type="text"
              value={version}
              onChange={(e) => onVersionChange(e.target.value)}
              placeholder="e.g., 1.0.0"
              className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 text-sm transition-colors hover:border-blue-400 focus:border-blue-500 focus:outline-none"
            />
            <p className="text-xs text-gray-600 dark:text-gray-400 mt-1">Optional version identifier</p>
          </div>
        </div>
      </div>

      {/* Help Text */}
      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900 dark:bg-opacity-30 border border-blue-200 dark:border-blue-700 rounded-lg">
        <p className="text-xs text-blue-800 dark:text-blue-300">
          <span className="font-medium">💡 Tip:</span> Click "Load Template" to populate the JSON editor with a sample request. Edit it and submit to test the classification service.
        </p>
      </div>
    </div>
  );
}
